// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3QT8u","checkboxCol":"Table_checkboxCol__3Flna","emailCol":"Table_emailCol__zUdap","actionCol":"Table_actionCol__1PLoI"};